<template>
  <ul :ref="'tabs' + idNav" class="nav nav-tabs flex flex-col md:flex-row flex-nowrap overflow-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-200 list-none border-b-0 pl-0 mb-4 max-h-44" :id="idNav"
    role="tablist"
    :class="classHead">
    <tab-item @click="selectTab(item.idTab, index)" v-for="(item, index) in items" :classes="itemClass" v-bind="item" :selected="this.selectedIndex == index">\
      <template #title v-if="hasSlot('title.' + item.idTab)">
        <slot :key="'title.' + item.idTab" :name="'title.' + item.idTab" />
      </template>
    </tab-item>
  </ul>
  <div class="tab-content" :id="idContent">
    <tab-content v-for="(item, index) in items" v-bind="item" :selected="this.selectedIndex == index">
      <template #content v-show="hasSlot('content.' + item.idTab)">
        <slot :key="'content.' + item.idTab" :name="'content.' + item.idTab" />
      </template>
    </tab-content>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid'
import TabItem from '@/Shared/Components/Tabs/TabItem'
import TabContent from '@/Shared/Components/Tabs/TabContent'

export default {
  emits: ["changeTab"],
  components: {
    TabItem,
    TabContent,
  },
  props: {
    idNav: {
      type: String,
      default() {
        return `tabs-tab-${uuid()}`
      },
    },
    idContent: {
      type: String,
      default() {
        return `tabs-tabContent-${uuid()}`
      },
    },
    selectedItemIndex: {
      type: Number,
      default: 0,
    },
    classHead: {
      type: String,
      default: '',
    },
    itemClass: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default() {
        return [
          {
            idTab: 'tab-default',
            title: 'TAB',
            content: 'CONTENT',
          }
        ]
      },
    },
  },
  data() {
    return {
      selectedTab: null,
      selectedIndex: 0
    }
  },
  methods: {
    hasSlot (name = 'default') {
      return !!this.$slots[ name ];
    },
    selectTab: function(tab, index) {
      this.selectedTab = tab;
      this.selectedIndex = index;
    },
  },
  mounted() {
    this.selectedIndex = this.selectedItemIndex;
    this.selectedTab = this.$refs['tabs' + this.idNav].querySelector('.active').id.replace('tabs-', '').replace('-tab', '');
  },
  watch: {
    selectedItemIndex(value) {
      this.selectedIndex = this.selectedItemIndex
    }, 

    selectedTab(value_new, value_old) {
      this.$emit('changeTab', {selectedTab: this.selectedTab, value_new: value_new, value_old: value_old});
    },
  }
}
</script>